<template>
  <div class="cache-management">
    <div class="cache-pattern-input">
      <label for="cache-pattern-input" class="visually-hidden">{{ t('admin.cache.pattern_placeholder') }}</label>
      <input
        id="cache-pattern-input"
        v-model="pattern"
        type="text"
        class="pattern-input"
        :placeholder="t('admin.cache.pattern_placeholder')"
        @keyup.enter="search" />
      <backstage-button @click="search">
        {{ t('admin.cache.search') }}
      </backstage-button>
      <backstage-button :variant="ButtonVariant.SECONDARY" @click="clearCache">
        {{ t('admin.cache.clear_all') }}
      </backstage-button>
    </div>
    <grid-cache-keys :key="reloadGrid" :pattern="searchedPattern" @keys-deleted="reloadGrid++" />
  </div>
</template>
<script setup lang="ts">
import { useNotification } from '@/composables/useNotification';
import { ButtonVariant } from '@/models/button-variant.enum';
import { CacheAdminService } from '@/services/cache-admin.service';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import GridCacheKeys from '../../components/cache/grid-cache-keys.vue';
import BackstageButton from '../../components/common/BackstageButton.vue';

const { t } = useI18n();
const { notifySuccess, notifyError } = useNotification();
const cacheAdminService = new CacheAdminService();

const pattern = ref('');
const searchedPattern = ref('*');
const reloadGrid = ref(0);

function search() {
  searchedPattern.value = pattern.value || '*';
  reloadGrid.value++;
}

async function clearCache() {
  if (!window.confirm(t('admin.cache.clear_all_confirm'))) {
    return;
  }

  const result = await cacheAdminService.clearAll();

  if (result.success) {
    notifySuccess(t('admin.cache.cache_cleared'));
    reloadGrid.value++;
  } else {
    notifyError(t('admin.cache.error_clearing_cache'));
  }
}
</script>
<style lang="scss">
.cache-management {
  @include main-max-with;

  padding: 20px 10px 0;
  width: 100%;
  margin: 0 auto;

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .cache-pattern-input {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;

    .pattern-input {
      flex: 1;
      height: 45px;
      padding: 0 15px;
      background-color: var(--primary-bg-color);
      border: 1px solid var(--border-color);
      color: var(--primary-text-input-color);
    }
  }
}
</style>
